export const generateUuid = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
    const random = Math.floor(Math.random() * 16);
    const value = character === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
};

const createEmptyOverride = () => ({
  sdkDeviceFeature: '',
  sdkFeature: '',
});

export const createSDKApp = () => ({
  apiKey: generateUuid(),
  bundleId: '',
  featureSetId: '',
  addOverrides: [createEmptyOverride()],
  removeOverrides: [createEmptyOverride()],
  enabled: true,
  collectMeasurements: true,
  collectTelemetry: true,
});

export const isOverridePairValid = (left, right) => (!left && !right) || (left && right);

const normalizeOverrideList = (overrides) => {
  if (!Array.isArray(overrides) || overrides.length === 0) {
    return [createEmptyOverride()];
  }

  return overrides.map((override) => ({
    sdkDeviceFeature: override?.sdkDeviceFeature || '',
    sdkFeature: override?.sdkFeature || '',
  }));
};

const buildOverrideList = (overrides) => {
  if (!Array.isArray(overrides)) return [];

  return overrides
    .filter((override) => override?.sdkDeviceFeature && override?.sdkFeature)
    .map((override) => ({
      sdkFeature: override.sdkFeature,
      sdkDeviceFeature: override.sdkDeviceFeature,
    }));
};

export const buildOverrides = (app) => {
  const overrides = {};
  const addOverrides = buildOverrideList(app.addOverrides);
  const removeOverrides = buildOverrideList(app.removeOverrides);

  if (addOverrides.length > 0) {
    overrides.add = addOverrides;
  }

  if (removeOverrides.length > 0) {
    overrides.remove = removeOverrides;
  }

  return Object.keys(overrides).length ? overrides : undefined;
};

export const hydrateSDKApp = (app) => {
  return {
    apiKey: app?.apiKey || generateUuid(),
    bundleId: app?.bundleId || '',
    featureSetId: app?.featureSetId || '',
    addOverrides: normalizeOverrideList(app?.overrides?.add),
    removeOverrides: normalizeOverrideList(app?.overrides?.remove),
    enabled: typeof app?.enabled === 'boolean' ? app.enabled : true,
    collectMeasurements: typeof app?.collectMeasurements === 'boolean' ? app.collectMeasurements : true,
    collectTelemetry: typeof app?.collectTelemetry === 'boolean' ? app.collectTelemetry : true,
  };
};

export const isSDKAppValid = (app) =>
  Boolean(app.apiKey && app.bundleId.trim() && app.featureSetId) &&
  (app.addOverrides || []).every((override) =>
    isOverridePairValid(override?.sdkDeviceFeature, override?.sdkFeature)
  ) &&
  (app.removeOverrides || []).every((override) =>
    isOverridePairValid(override?.sdkDeviceFeature, override?.sdkFeature)
  );
